import { defaultDocumentType } from '@constants/regions';
import { capitalize } from '@helpers';
import {
  SET_LOGIN_DATA,
  SET_JWT,
  SET_MERCHANTS,
  ADD_BANK_ACCOUNT,
  DISABLE_BANK_ACCOUNTS,
  DELETE_LOGIN_VALUES,
  SET_USER_AUTH,
  DELETE_USER_AUTH,
  SET_RECOVER_EMAIL,
  SET_DOCUMENT_STATUS,
  SET_TOKEN,
  SET_LINK,
  SET_LOGUED_AS,
  SET_AUTH,
  SET_ACCESS_CONTROL,
  UPDATE_AUTO_CASHOUT,
  SET_TERMS_EXPIRATION_DATE,
  SET_TERMS_VERSION,
  SET_IS_TERMS_EXPIRED,
  SET_TERMS_CONDITIONS,
  SET_USERS_BY_RUT,
  SET_ERROR_USERS_BY_RUT,
  CLEAN_USERS_BY_RUT,
  SUCCESS_DISABLE_VIEW_POP_UP,
} from './actionTypes';

export const initialState = {
  merchant: {
    is_legal_agent: null,
    roles: null,
    activity: '',
    address: '',
    _id: '',
    address_info: '',
    business_name: '',
    country: '',
    document: {},
    legal_agent: {
      phones: [],
      document: {},
      first_name: '',
      last_name: '',
      email: '',
      email_verification: true,
    },
    document_status: [
      {
        status: 'APPROVED',
        type: capitalize(defaultDocumentType),
        updated_at: '',
      },
      {
        status: 'REJECTED',
        type: '',
        updated_at: '',
      },
    ],
    merchant_name: '',
    merchant_type: '',
    one_day_company: false,
    merchants: [
      {
        id: '',
        business_name: '',
      },
    ],
    bank_accounts: [],
  },
  saved_info: {
    email: '',
    password: '',
  },
  recover_email: '',
  recover_user: null,
  recover_error_user: '',
  token: '',
  jwt: {
    access_token: '',
    refresh_token: '',
    expires_in: '',
    token_type: '',
  },
  auth: null,
  loguedAs: null,
  link: 'linkdeRedux',
  terms_expiration_date: null,
  terms_version: null,
  is_terms_expired: false,
  termsConditions: null,
  is_expired: false,
};
export default (state = initialState, action) => {
  switch (action.type) {
    case SET_LOGIN_DATA: {
      return {
        ...state,
        merchant: action.payload,
      };
    }
    case SET_DOCUMENT_STATUS: {
      state.merchant.document_status = action.payload;
      return {
        ...state,
      };
    }
    case SET_LINK: {
      return {
        ...state,
        link: action.payload,
      };
    }
    case SET_TERMS_EXPIRATION_DATE: {
      return {
        ...state,
        terms_expiration_date: action.payload,
      };
    }
    case SET_TERMS_VERSION: {
      return {
        ...state,
        terms_version: action.payload,
      };
    }
    case SET_IS_TERMS_EXPIRED: {
      return {
        ...state,
        is_terms_expired: action.payload,
      };
    }
    case SET_TERMS_CONDITIONS: {
      return {
        ...state,
        termsConditions: action.payload,
      };
    }
    case SET_RECOVER_EMAIL: {
      return {
        ...state,
        recover_email: action.payload,
      };
    }
    case SET_TOKEN: {
      return {
        ...state,
        token: action.payload,
      };
    }
    case SUCCESS_DISABLE_VIEW_POP_UP: {
      state.merchant.view_popup = false;
      return {
        ...state,
      };
    }
    case DELETE_USER_AUTH: {
      return {
        ...state,
        saved_info: { password: '', email: '' },
      };
    }
    case SET_USER_AUTH: {
      let aux = initialState.saved_info;
      aux = action.payload;
      return {
        ...state,
        saved_info: aux,
      };
    }
    case DISABLE_BANK_ACCOUNTS: {
      return {
        ...state,
        merchant: {
          ...state.merchant,
          bank_accounts: state.merchant.bank_accounts.map((el) => ({ ...el, enabled: false })),
        },
      };
    }
    case ADD_BANK_ACCOUNT: {
      return {
        ...state,
        merchant: {
          ...state.merchant,
          bank_accounts: [...state.merchant.bank_accounts, action.payload],
        },
      };
    }
    case SET_MERCHANTS: {
      return {
        ...state,
        merchants: action.payload,
      };
    }
    case DELETE_LOGIN_VALUES: {
      const aux = state.saved_info;
      return {
        ...initialState,
        is_expired: action.payload,
        saved_info: aux,
      };
    }
    case SET_JWT: {
      const jwt = { ...action.payload };
      return {
        ...state,
        jwt,
      };
    }
    case SET_LOGUED_AS: {
      const loguedAs = { ...action.payload };
      state.merchant.is_legal_agent = loguedAs.is_legal_agent;
      state.merchant.roles = loguedAs.roles;
      return {
        ...state,
        loguedAs,
      };
    }
    case SET_AUTH: {
      return {
        ...state,
        auth: action.payload,
      };
    }
    case SET_ACCESS_CONTROL: {
      return {
        ...state,
        accessControl: action.payload,
      };
    }
    case UPDATE_AUTO_CASHOUT: {
      return {
        ...state,
        merchant: {
          ...state.merchant,
          auto_cashout: !state.merchant.auto_cashout,
        },
      };
    }
    case SET_USERS_BY_RUT: {
      return {
        ...state,
        recover_user: action.payload,
      };
    }
    case SET_ERROR_USERS_BY_RUT: {
      return {
        ...state,
        recover_error_user: action.payload,
      };
    }
    case CLEAN_USERS_BY_RUT: {
      return {
        ...state,
        recover_user: null,
      };
    }
    default:
      return {
        ...state,
      };
  }
};
